export function registerPWAUpdate(onUpdateAvailable: () => void) {
  if (!('serviceWorker' in navigator)) return

  navigator.serviceWorker.register('/sw.js').catch(err => {
    console.warn('[pwa] sw registration failed', err)
  })

  navigator.serviceWorker.ready.then(registration => {
    if (registration.waiting) {
      onUpdateAvailable()
      return
    }
    registration.addEventListener('updatefound', () => {
      const newWorker = registration.installing
      if (!newWorker) return
      newWorker.addEventListener('statechange', () => {
        if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
          onUpdateAvailable()
        }
      })
    })
  })

  let refreshing = false
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return
    refreshing = true
    window.location.reload()
  })

  // iOS installé — la PWA gelée en arrière-plan ne re-checke jamais
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState !== 'visible') return
    navigator.serviceWorker.getRegistration().then(reg => reg?.update())
  })
}

export function applyPWAUpdate() {
  navigator.serviceWorker.ready.then(registration => {
    registration.waiting?.postMessage({ type: 'SKIP_WAITING' })
  })
}
